module.exports = __webpack_public_path__ + "media/images/missing-fa7d4a80.png";